import { iConfiguracion } from "./../../models/basePage";
import { Component } from "@angular/core";
import {
  IonicPage,
  LoadingController,
  ToastController,
  Modal,
  ModalController,
  ActionSheetController,
  ActionSheet,
} from "ionic-angular";
import { Proxy } from "../../services/proxy/proxy.service";
import { APIOnLine } from "../../services/api/api.services";
import { pouchdb2 } from "../../services/pouchdb/pouchdb.service";
import { PaginaBasica } from "../../models/PaginaBase";
import { NuevaPersonaPage } from "../nueva-persona/nueva-persona";
import { ModalImagePage } from "../modal-image/modal-image";

@IonicPage()
@Component({
  selector: "page-auxiliares",
  templateUrl: "auxiliares.html",
})
export class AuxiliaresPage extends PaginaBasica {
  // #region Propiedades de la página
  public configuraciones: iConfiguracion;
  public designacion: Proxy.PrDesignaciones;
  public idEquipo: number;
  public licencias: Proxy.ListaPrPersonaAlineable;
  public participantes: Proxy.ListaPrParticipacion;
  public listaDelegados: Array<Proxy.PrPersonaAlineable> = [];
  // #endregion

  // #region Nuevas propiedades para la nueva funcionalidad de la página de auxiliares.
  public dobleFuncionDelegado: boolean = false;
  public delegadosDistintos: boolean = false;
  public presentaDelegadoEquipo: string = "";
  public presentaDelegadoCampo: string = "";
  // #endregion

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public Persistentes: APIOnLine.Persistentes,
    public toastCtrl: ToastController
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidEnter() {
    console.log("--- ENTRO EN LA PÁGINA: AUXILIARES ---");
    this.designacion = this.Persistentes.GetDesignacion();
    this.idEquipo = this.Persistentes.GetIdEquipo();

    this.participantes = new Proxy.ListaPrParticipacion(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes,
      this.toastCtrl,
      this.designacion,
      this.idEquipo
    );
    this.licencias = new Proxy.ListaPrPersonaAlineable(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes,
      this.designacion,
      this.idEquipo
    );
    this.CargarListaDelegados(true);
  }

  // #region Métodos del controlador

  /**
   * Proceso interno para cargar la lista de delegados. Cuando ya se ha establecido los delegados, solamente se mostrará en la lista, aquellos que estén marcados como tal
   * @param mostrarCarga    Indica si se desea que se muestre el loading de carga
   */
  private CargarListaDelegados(mostrarCarga: boolean): void {
    if (mostrarCarga) {
      this.MostrarOcultarCarga(false, "cargando auxiliares");
    }

    this.listaDelegados = [];

    this.Persistentes.GetConfiguracion()
      .then((resultado: iConfiguracion) => {
        this.configuraciones = resultado;
        return this.participantes.CargarListaParticipacion();
      })
      .then((resultado: boolean) => {
        return this.licencias.ObtenerAlineables(false, true, true);
      })
      .then((resultado: boolean) => {
        let entrenadoresDelegados: string[] =
          this.configuraciones.internas.entrenadorDelegado.split(",");

        // Filtrado de los alineables obtenidos, para que solamente se muestren los delegados y/o los entrenadores.
        if (this.licencias != null && this.licencias.lista != null) {
          this.licencias.lista = this.licencias.lista.filter(m => (m.tipoLicencia.indexOf("DELEGADO") >= 0) ||
            (m.tipoLicencia.indexOf("ENTRENADOR") >= 0 && m.esEntrenador) ||
            (m.tipoLicencia.indexOf("MONITOR") >= 0 && m.esEntrenador) ||
            (m.tipoLicencia.indexOf("MATERIAL") >= 0 && m.esAuxiliar) ||
            (m.tipoLicencia.indexOf("SANITARIO") >= 0 && m.esAuxiliar));
        }

        if (this.licencias != null && this.licencias.lista != null) {
          this.licencias.lista.forEach((valor: Proxy.PrPersonaAlineable) => {
            // Se filtraran los resultados, dependiendo de si ya se ha establecido los delegados (para mostrar solo los seleccionados)
            if (
              !this.FuncionDelegadoEstablecida() ||
              (this.FuncionDelegadoEstablecida() &&
                (this.participantes.EsDelegado(valor, false) ||
                  this.participantes.EsDelegado(valor, true) ||
                  entrenadoresDelegados.filter(
                    (m) =>
                      m.toUpperCase() ==
                      valor.codigoTipoLicencia.toUpperCase().trim()
                  ).length > 0))
            ) {
              // Se comprueba si la licencia es de un delegado de campo y si es el equipo visitante. En este caso, no se debe incluir la licencia
              if (
                this.designacion.EquipoLocal(this.idEquipo) ||
                (!this.designacion.EquipoLocal(this.idEquipo) &&
                  valor.tipoLicencia != "DELEGADO CAMPO")
              ) {
                this.listaDelegados.push(valor);
              }
            }
          });
        }

        if (
          this.designacion.EquipoLocal(this.idEquipo) &&
          (this.designacion.OtrosDatos.dobleFuncionDelegado ||
            this.designacion.OtrosDatos.delegadosDistintos)
        ) {
          this.dobleFuncionDelegado =
            this.designacion.OtrosDatos.dobleFuncionDelegado;
          this.delegadosDistintos =
            this.designacion.OtrosDatos.delegadosDistintos;

          if (this.designacion.OtrosDatos.noExisteDelegadoEquipoLocal) {
            this.presentaDelegadoEquipo = "no";
          } else if (this.participantes.TieneDelegado(false)) {
            this.presentaDelegadoEquipo = "si";
          }
          if (this.designacion.OtrosDatos.noExisteDelegadoCampo) {
            this.presentaDelegadoCampo = "no";
          } else if (
            this.designacion.EquipoLocal(this.idEquipo) &&
            this.participantes.TieneDelegado(true)
          ) {
            this.presentaDelegadoCampo = "si";
          }
        } else if (!this.designacion.EquipoLocal(this.idEquipo)) {
          if (this.designacion.OtrosDatos.noExisteDelegadoEquipoVisitante) {
            this.presentaDelegadoEquipo = "no";
          } else if (this.participantes.TieneDelegado(false)) {
            this.presentaDelegadoEquipo = "si";
          }
        }

        if (mostrarCarga) {
          this.MostrarOcultarCarga(true);
        }
      })
      .catch((error) => console.error(error));
  }

  public ColorDelegado(
    licencia: Proxy.PrPersonaAlineable,
    campo: boolean
  ): string {
    if (this.participantes.EsDelegado(licencia, campo)) {
      return "auburn";
    } else {
      return "concrete";
    }
  }

  /**
   * Elimina toda la información incluida en la aplicación referente a los delegados
   */
  public EliminarDelegados(): void {
    let actionSheet = this.actionSheetCtrl.create({
      title: "Eliminar información de los delegados",
      subTitle:
        "Al pulsar sobre el botón de ELIMINACIÓN COMPLETA, se reiniciará la información relacionada con los delegados.",
      buttons: [
        {
          text: "ELIMINACIÓN COMPLETA",
          handler: () => {
            if (this.designacion.EquipoLocal(this.idEquipo)) {
              this.designacion.OtrosDatos.delegadosDistintos = false;
              this.designacion.OtrosDatos.dobleFuncionDelegado = false;
              this.designacion.OtrosDatos.noExisteDelegadoCampo = false;
              this.designacion.OtrosDatos.noExisteDelegadoEquipoLocal = false;
            } else {
              this.designacion.OtrosDatos.noExisteDelegadoEquipoVisitante =
                false;
            }

            this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
            this.designacion.OtrosDatos.urlNombre = this.designacion.urlNombre;

            this.MostrarOcultarCarga(true, "eliminando datos");
            this.designacion.OtrosDatos.Guardar()
              .then((resultado: boolean) => {
                return this.participantes.EliminarDelegados();
              })
              .then((resultado: boolean) => {
                // He puesto este timeout aquí, porque se estaba enviando la obtención de los participantes, antes de que se guardara la eliminación de los delegados, debido a la petición OPTIONS
                setTimeout(() => {
                  this.MostrarOcultarCarga(true);
                  this.participantes = new Proxy.ListaPrParticipacion(
                    this.CFutbolActas,
                    this.DBService2,
                    this.Persistentes,
                    this.toastCtrl,
                    this.designacion,
                    this.idEquipo
                  );
                  this.CargarListaDelegados(true);

                  this.dobleFuncionDelegado = false;
                  this.delegadosDistintos = false;
                  this.presentaDelegadoEquipo = "";
                  this.presentaDelegadoCampo = "";
                }, 2000);
              })
              .catch((error) =>
                this.Error(
                  error,
                  "Eliminación de la información de los delegados"
                )
              );
          },
        },
        {
          text: "Cancelar",
          role: "cancel",
        },
      ],
    });
    actionSheet.present();
  }

  public EliminarParticipante(licencia: Proxy.PrPersonaAlineable): void {
    let actionSheet = this.actionSheetCtrl.create({
      title: "Eliminar participante",
      subTitle:
        "¿Desea eliminar de la lista de auxiliares a " +
        licencia.nombre +
        " " +
        licencia.apellido1 +
        " " +
        licencia.apellido2 +
        "?",
      buttons: [
        {
          text: "Eliminar",
          handler: () => {
            console.log("Datos de la licencia a eliminar: ");
            console.log(licencia);

            this.participantes.EliminarParticipante(licencia);
            this.licencias.EliminarAlineado(licencia);
            this.CargarListaDelegados(true);
          },
        },
        {
          text: "Cancelar",
          role: "cancel",
        },
      ],
    });
    actionSheet.present();
  }

  /**
   * Presenta la ventana modal para añadir un nuevo DELEGADO DE CAMPO
   */
  public NuevoDelegadoCampo(): void {
    let modal: Modal = this.modalCtrl.create(NuevaPersonaPage, {
      esAuxiliar: true,
      esEntrenador: false,
      delegadoEquipo: false,
      delegadoCampo: true,
    });
    modal.onDidDismiss(() => {
      this.participantes
        .CargarListaParticipacion()
        .then((resultado: boolean) => {
          return this.licencias.ObtenerAlineables(false, false, true);
        })
        .then((resultado: boolean) => {
          this.CargarListaDelegados(true);
        })
        .catch((error) => console.error(error));
    });
    modal.present();
  }

  /**
   * Presenta la ventana modal para añadir un nuevo DELEGADO DE EQUIPO
   */
  public NuevoDelegadoEquipo(): void {
    let modal: Modal = this.modalCtrl.create(NuevaPersonaPage, {
      esAuxiliar: true,
      esEntrenador: false,
      delegadoEquipo: true,
      delegadoCampo: false,
    });
    modal.onDidDismiss(() => {
      this.participantes
        .CargarListaParticipacion()
        .then((resultado: boolean) => {
          return this.licencias.ObtenerAlineables(false, false, true);
        })
        .then((resultado: boolean) => {
          this.CargarListaDelegados(true);
        })
        .catch((error) => console.error(error));
    });
    modal.present();
  }

  /**
   * Muestra una ventana modal con la foto asociada a la persona
   * @param licencia Datos de la licencia
   */
  public VerFoto(licencia: Proxy.PrPersonaAlineable): void {
    let modal: Modal = this.modalCtrl.create(ModalImagePage, {
      dni: licencia.identificador,
    });
    modal.present();
  }

  // #endregion

  // #region Métodos para el control de la existencia de los delegados y doble funcionalidad
  public CambioDobleFuncion(): void {
    setTimeout(() => {
      //this.designacion.OtrosDatos.dobleFuncionDelegado = true;
      if (this.dobleFuncionDelegado) {
        this.delegadosDistintos = false;
        //this.designacion.OtrosDatos.delegadosDistintos = false;
      }
    }, 100);
  }

  public CambioDelegadosDistintos(): void {
    setTimeout(() => {
      //this.designacion.OtrosDatos.delegadosDistintos = true;
      if (this.delegadosDistintos) {
        this.dobleFuncionDelegado = false;
        //this.designacion.OtrosDatos.dobleFuncionDelegado = false;
      }
    }, 100);
  }

  /**
   * Desactiva la posibilidad de seleccionar el delegado de equipo
   */
  public DesactivarDelegadoEquipo(): void {
    if (
      (this.designacion.EquipoLocal(this.idEquipo) &&
        !this.designacion.OtrosDatos.noExisteDelegadoEquipoLocal) ||
      (!this.designacion.EquipoLocal(this.idEquipo) &&
        !this.designacion.OtrosDatos.noExisteDelegadoEquipoVisitante)
    ) {
      let action: ActionSheet = this.actionSheetCtrl.create({
        buttons: [
          {
            text: "NO PRESENTA",
            handler: () => {
              if (this.designacion.EquipoLocal(this.idEquipo)) {
                this.designacion.OtrosDatos.delegadosDistintos = true;
                this.designacion.OtrosDatos.noExisteDelegadoEquipoLocal = true;
              } else {
                this.designacion.OtrosDatos.noExisteDelegadoEquipoVisitante =
                  true;
              }

              if (this.participantes.TieneDelegado(false)) {
                this.participantes.lista.forEach(
                  (valor: Proxy.PrParticipacion) => {
                    if (valor.esDelegado) {
                      valor.esDelegado = false;
                      valor.Guardar();
                    }
                  }
                );
              }

              this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
              this.designacion.OtrosDatos.urlNombre =
                this.designacion.urlNombre;

              this.designacion.OtrosDatos.Guardar().then(
                (resultado: boolean) => {
                  this.Mensaje(
                    "El equipo " +
                    (this.designacion.EquipoLocal(this.idEquipo)
                      ? this.designacion.local
                      : this.designacion.visitante) +
                    " no presenta delegado de equipo."
                  );
                }
              );
            },
          },
          {
            text: "Cancelar",
            role: "cancel",
            handler: () => {
              this.presentaDelegadoEquipo = "";
            },
          },
        ],
        title: "No presenta delegado de equipo",
        subTitle:
          "Seleccione la opción de NO PRESENTA para indicar que el equipo " +
          (this.designacion.EquipoLocal(this.idEquipo)
            ? "LOCAL"
            : "VISITANTE") +
          " no presenta delegado de equipo.",
      });
      action.present();
    }
  }

  /**
   * Desactiva la posibilidad de seleccionar el delegado de campo
   */
  public DesactivarDelegadoCampo(): void {
    if (!this.designacion.OtrosDatos.noExisteDelegadoCampo) {
      let action: ActionSheet = this.actionSheetCtrl.create({
        buttons: [
          {
            text: "NO PRESENTA",
            handler: () => {
              this.designacion.OtrosDatos.delegadosDistintos = true;
              this.designacion.OtrosDatos.noExisteDelegadoCampo = true;

              if (this.participantes.TieneDelegado(true)) {
                this.participantes.lista.forEach(
                  (valor: Proxy.PrParticipacion) => {
                    if (valor.esDelegadoCampo) {
                      valor.esDelegadoCampo = false;
                      valor.Guardar();
                    }
                  }
                );
              }

              this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
              this.designacion.OtrosDatos.urlNombre =
                this.designacion.urlNombre;

              this.designacion.OtrosDatos.Guardar().then(
                (resultado: boolean) => {
                  this.Mensaje(
                    "El equipo " +
                    this.designacion.local +
                    " no presenta delegado de campo."
                  );
                }
              );
            },
          },
          {
            text: "Cancelar",
            role: "cancel",
            handler: () => {
              this.presentaDelegadoCampo = "";
            },
          },
        ],
        title: "No presenta delegado de campo",
        subTitle:
          "Seleccione la opción de NO PRESENTA para indicar que el equipo LOCAL no presenta delegado de campo.",
      });
      action.present();
    }
  }

  /**
   * Indica si ya se han establecido las funciones de delegado
   */
  public FuncionDelegadoEstablecida(): boolean {
    let resultado: boolean = false;

    if (this.designacion != null) {
      if (this.designacion.EquipoLocal(this.idEquipo)) {
        // Para el equipo local
        if (
          this.designacion.OtrosDatos != null &&
          (this.designacion.OtrosDatos.dobleFuncionDelegado ||
            (this.designacion.OtrosDatos.delegadosDistintos &&
              this.FuncionalidadDeDosDelegadosEstablecida()))
        ) {
          resultado = true;
        }
      } else {
        // Para el equipo visitante
        if (
          this.designacion.OtrosDatos != null &&
          this.FuncionalidadDeDosDelegadosEstablecida()
        ) {
          resultado = true;
        }
      }
    }

    return resultado;
  }

  /**
   * Indica si se han indicado los datos de los delegado de equipo y de campo para el equipo local o el delegado de equipo para el equipo visitante
   */
  public FuncionalidadDeDosDelegadosEstablecida(): boolean {
    let resultado: boolean = false;

    if (this.designacion.EquipoLocal(this.idEquipo)) {
      // Para el equipo local
      if (
        this.designacion.OtrosDatos.noExisteDelegadoCampo &&
        this.designacion.OtrosDatos.noExisteDelegadoEquipoLocal
      ) {
        return true;
      } else if (
        this.designacion.OtrosDatos.noExisteDelegadoCampo &&
        this.participantes.TieneDelegado(false, false)
      ) {
        return true;
      } else if (
        this.designacion.OtrosDatos.noExisteDelegadoEquipoLocal &&
        this.participantes.TieneDelegado(true, false)
      ) {
        return true;
      } else if (
        this.participantes.TieneDelegado(false, false) &&
        this.participantes.TieneDelegado(true, false)
      ) {
        return true;
      }
    } else {
      // Para el equipo visitante
      if (
        this.designacion.OtrosDatos.noExisteDelegadoEquipoVisitante ||
        this.participantes.TieneDelegadoMarcado(false)
      ) {
        resultado = true;
      }
    }

    return resultado;
  }

  /**
   * Establece la licencia, como delegado de equipo o de campo
   * @param licencia Datos de la licencia
   * @param campo Indica si es delegado de campo o delegado de equipo
   */
  public MarcarDelegado(
    licencia: Proxy.PrPersonaAlineable,
    campo: boolean
  ): void {
    this.participantes.MarcarComoDelegado(licencia, campo);

    if (this.designacion.EquipoLocal(this.idEquipo)) {
      this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
      this.designacion.OtrosDatos.urlNombre = this.designacion.urlNombre;

      this.designacion.OtrosDatos.delegadosDistintos = true;
      this.designacion.OtrosDatos.Guardar();
    }
  }

  /**
   * Establece la licencia, como delegado de equipo y delegado de campo (doble función)
   * @param licencia Datos de la licencia
   */
  public MarcarDobleFuncion(licencia: Proxy.PrPersonaAlineable): void {
    // Confirmación de que se quiere marcar a la persona con la doble función
    let action: ActionSheet = this.actionSheetCtrl.create({
      buttons: [
        {
          text: "Marcar Doble Función",
          handler: () => {
            console.log("Llego");
            this.participantes.MarcarDobleFuncion(licencia);

            this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
            this.designacion.OtrosDatos.urlNombre = this.designacion.urlNombre;

            // Guardado en Actas_Otros, la doble funcionalidad
            this.designacion.OtrosDatos.dobleFuncionDelegado = true;
            this.designacion.OtrosDatos.delegadosDistintos = false;
            this.designacion.OtrosDatos.noExisteDelegadoCampo = false;
            this.designacion.OtrosDatos.noExisteDelegadoEquipoLocal = false;
            this.designacion.OtrosDatos.Guardar().then((resultado: boolean) => {
              this.Mensaje(
                "El club local ha efectuado el nombramiento para el ejercicio de la doble función de delegado."
              );

              this.CargarListaDelegados(false);
            });
          },
        },
        {
          text: "Cancelar",
          role: "cancel",
        },
      ],
      title: "Doble función de delegado",
      subTitle:
        "¿Desea establecer a la persona seleccionada como Delegado de Equipo y Delegado de campo (Doble función)?. Quedará registrado así en el acta.",
    });
    action.present();
  }

  /**
   * Comprueba si se puede marcar a la persona como delegado de campo
   * @param persona Datos de la persona a comprobar
   * @returns Indica si se puede alinearse como delegado de campo
   */
  public PuedeSerDelegadoCampo(persona: Proxy.PrPersonaAlineable): boolean {
    if (this.designacion.EquipoLocal(this.idEquipo) && this.presentaDelegadoCampo == 'si' &&
      (persona.codigoTipoLicencia.trim() == 'DC' ||
        persona.tipoLicencia.indexOf('MATERIAL') >= 0 ||
        persona.tipoLicencia.indexOf('SANITARIO') >= 0 ||
        persona.tipoLicencia.indexOf('DELEGADO') >= 0)) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Comprueba si se puede marcar a la persona como delegado de equipo
   * @param persona Datos de la persona a comprobar
   * @returns Indica si puede alinearse como delegado de equipo
   */
  public PuedeSerDelegadoEquipo(persona: Proxy.PrPersonaAlineable): boolean {
    if (this.presentaDelegadoEquipo == 'si' &&
      persona.tipoLicencia.indexOf('CAMPO') < 0 &&
      (persona.tipoLicencia.indexOf('DELEGADO') >= 0 || persona.tipoLicencia.indexOf('ENTRENADOR') >= 0 || persona.tipoLicencia.indexOf('MONITOR') >= 0)) {
      return true;
    } else {
      return false;
    }
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/pages/auxiliares/auxiliares.ts